export const COMPANY = {
  name: "StoneCrest",
  full: "StoneCrest Exterior Specialists",
  phone: "+44 7307352758",
  phoneHref: "tel:+447307352758",
  whatsapp: "447307352758",
  email: "info@stonecrestexteriors.co.uk",
  address: "The Exchange, Flat 8 Percy Street, PR1 1AW, Preston",
  region: "Lancashire",
  hours: [
    { day: "Monday – Friday", time: "8:00 – 18:00" },
    { day: "Saturday", time: "9:00 – 16:00" },
    { day: "Sunday", time: "Closed" },
  ],
};

export const IMAGES = {
  heroDusk: "https://static.prod-images.emergentagent.com/jobs/881a4248-c33f-4612-9b07-29be64415b85/images/c7636af3173b3a9f22ba4a23ba4aec599f3960fc09d16be674d3faa18dfe85f9.jpeg",
  heroPrimary: "https://images.unsplash.com/photo-1674280826600-55f83510e7e3?w=1400&q=85",
  heroSecondary: "https://images.unsplash.com/photo-1667082802241-9deec6d7e252?w=1200&q=85",
  about: "https://images.unsplash.com/photo-1661936134570-9b21f69e427c?w=1400&q=85",
  reviews: "https://images.unsplash.com/photo-1729897671630-b335eca8045f?w=1600&q=85",
  contact: "https://images.unsplash.com/photo-1776655890108-b8b0a8f3b5cf?w=1600&q=85",
};

export const SERVICES = [
  {
    slug: "roof-cleaning",
    name: "Roof Cleaning",
    tagline: "Moss removal & softwash roof restoration",
    image: "https://images.unsplash.com/photo-1728257471500-4bacef65a2c6?w=1200&q=85",
    description:
      "Moss, algae and lichen don't just look unsightly — they trap moisture and shorten the life of your roof. Our softwash roof cleaning gently removes organic growth and applies a biocide treatment that keeps tiles cleaner for longer, all without the high-pressure blasting that can crack or dislodge them.",
    benefits: [
      "Removes moss, algae, lichen and black streaking",
      "Gentle softwash method protects tiles and mortar",
      "Long-lasting biocide treatment included",
      "Improves kerb appeal and protects roof lifespan",
      "Safe working practices and full insurance",
    ],
    faqs: [
      { q: "How long does roof cleaning last?", a: "With our biocide treatment, most roofs stay visibly clean for 2–4 years. Results vary with tree cover and shade." },
      { q: "Is softwashing safe for my roof?", a: "Yes. Softwashing uses low pressure and a specialist solution, making it far safer for tiles and mortar than traditional pressure washing." },
      { q: "How much does roof cleaning cost?", a: "Every roof is different, so we provide a fixed-price quote after a free property assessment — no surprises." },
    ],
  },
  {
    slug: "render-softwashing",
    name: "Render Softwashing",
    tagline: "Restore rendered walls to a flawless finish",
    image: "https://images.unsplash.com/photo-1659384899570-49a0ad1f545a?w=1200&q=85",
    description:
      "Rendered walls are prone to green algae and red-brown organic staining, especially on shaded or north-facing elevations. Our softwashing process lifts the growth at the root and brightens the render to a like-new finish, safely and without damaging the coating.",
    benefits: [
      "Safe on silicone, acrylic, mineral and traditional renders",
      "Kills algae and spores at the root, not just the surface",
      "No aggressive pressure that can damage render",
      "Dramatically brightens the whole facade",
      "Protective treatment slows regrowth",
    ],
    faqs: [
      { q: "How long does render cleaning last?", a: "Typically 18–36 months depending on aspect, shade and local conditions. Our treatment is designed to slow regrowth." },
      { q: "Do you clean all render types?", a: "Yes — we tailor the solution and method to your specific render, from modern silicone systems to traditional finishes." },
      { q: "Will softwashing damage my render?", a: "No. Softwashing is specifically chosen because it cleans effectively at low pressure, protecting the render coating." },
    ],
  },
  {
    slug: "driveway-patio-cleaning",
    name: "Driveway & Patio Cleaning",
    tagline: "Block paving, flags & natural stone restored",
    image: "https://images.unsplash.com/photo-1711098256664-d2ea62e6e376?w=1200&q=85",
    description:
      "Driveways and patios collect moss, weeds, oil and ingrained dirt over time. We deep-clean block paving, flags, tarmac and natural stone, then re-sand and optionally seal to leave a crisp, uniform finish that transforms the front of your home.",
    benefits: [
      "Deep cleans block paving, flags, stone and tarmac",
      "Removes moss, weeds, oil marks and ingrained grime",
      "Re-sanding of joints for a finished result",
      "Optional sealing to protect and enhance colour",
      "Tidy, careful work around your property",
    ],
    faqs: [
      { q: "How long does a driveway clean take?", a: "Most domestic driveways take between half a day and a full day, depending on size, surface and condition." },
      { q: "Do you re-sand block paving?", a: "Yes — kiln-dried sand is brushed into the joints as standard to stabilise the paving and complete the finish." },
      { q: "Can you remove weeds and moss?", a: "Absolutely. We remove existing growth and can apply a treatment to slow it returning." },
    ],
  },
  {
    slug: "gutter-clearing",
    name: "Gutter Clearing",
    tagline: "Blocked gutters cleared from the ground",
    image: "https://images.unsplash.com/photo-1582586285604-a136d08ab100?w=1200&q=85",
    description:
      "Blocked gutters cause overflow, damp and damage to fascias and walls. Using high-reach vacuum equipment we clear leaves, moss and debris safely from the ground — no ladders leaning against your home — and provide before-and-after camera confirmation.",
    benefits: [
      "Safe ground-based high-reach vacuum clearing",
      "Prevents overflow, damp and water damage",
      "Camera confirmation of cleared gutters",
      "No mess left behind",
      "Fully insured, careful team",
    ],
    faqs: [
      { q: "How often should gutters be cleared?", a: "We recommend at least once a year, or twice if your property is surrounded by trees." },
      { q: "Do you need ladders against my house?", a: "No — our high-reach vacuum system works safely from the ground, protecting your property." },
      { q: "Will you show me the results?", a: "Yes, we provide camera footage so you can see your gutters are properly cleared." },
    ],
  },
  {
    slug: "fascia-soffit-cleaning",
    name: "Fascia & Soffit Cleaning",
    tagline: "Brighten uPVC fascias, soffits & cladding",
    image: "https://images.unsplash.com/photo-1785351931221-313721c6c50b?w=1200&q=85",
    description:
      "Over time uPVC fascias, soffits and cladding pick up green algae, road grime and weathering that dull the whole roofline. We hand-clean and softwash these surfaces to restore their original bright white, finishing off the look of a freshly cleaned property.",
    benefits: [
      "Restores uPVC fascias, soffits and cladding",
      "Removes algae, grime and weathering marks",
      "Gentle methods that protect the finish",
      "Completes the look alongside roof and render cleaning",
      "Careful, detail-focused workmanship",
    ],
    faqs: [
      { q: "Can old uPVC be brought back to white?", a: "In most cases yes — our cleaning restores a significantly brighter, refreshed finish to weathered uPVC." },
      { q: "Do you clean the whole roofline?", a: "Yes, we cover fascias, soffits, bargeboards and cladding for a consistent, finished result." },
      { q: "Is it safe for older uPVC?", a: "Yes, we use gentle methods suited to the age and condition of the material." },
    ],
  },
];

export const WHY_CHOOSE = [
  { icon: "GraduationCap", title: "Professionally Trained", text: "Our team is trained in safe, modern exterior cleaning methods and best practice." },
  { icon: "ShieldCheck", title: "Fully Insured", text: "Comprehensive insurance cover on every job, for complete peace of mind." },
  { icon: "Sparkles", title: "Premium Equipment", text: "Professional softwash and high-reach systems for a superior, safer finish." },
  { icon: "Camera", title: "Before & After Reports", text: "Clear photo and camera confirmation of the work carried out." },
  { icon: "HeartHandshake", title: "Customer Satisfaction", text: "Meticulous attention to detail and a finish we're proud to stand behind." },
  { icon: "Leaf", title: "Safe Cleaning Methods", text: "Gentle softwashing that protects your property, plants and surroundings." },
];

export const PROCESS = [
  { n: "01", title: "Request Quote", text: "Get in touch by phone or through our quick online quote form." },
  { n: "02", title: "Property Assessment", text: "We assess your property and surfaces to plan the right approach." },
  { n: "03", title: "Fixed Price Quote", text: "A clear, fixed-price quote with no hidden costs or surprises." },
  { n: "04", title: "Professional Cleaning", text: "Careful, insured cleaning using premium equipment and safe methods." },
  { n: "05", title: "Final Inspection", text: "We inspect the finish together and capture before-and-after evidence." },
  { n: "06", title: "Customer Satisfaction", text: "We leave only when you're delighted with your transformed property." },
];

export const VALUES = [
  { title: "Premium Service", text: "We hold ourselves to a genuinely high standard on every single job." },
  { title: "Professionally Trained Staff", text: "Trained in the latest safe softwashing and cleaning techniques." },
  { title: "Attention to Detail", text: "It's the small things — a spotless finish, tidy site, careful work." },
  { title: "Respect for Your Property", text: "We treat your home, garden and surroundings with total care." },
  { title: "Fully Insured", text: "Complete insurance cover so you're protected at all times." },
  { title: "Reliable Communication", text: "Clear, prompt updates from first enquiry to final inspection." },
];

export const FAQS = [
  { q: "How long does render cleaning last?", a: "Typically 18–36 months depending on the aspect of the wall, surrounding shade and local conditions. Our treatment is designed to slow regrowth." },
  { q: "Is softwashing safe?", a: "Yes. Softwashing uses low pressure with a specialist cleaning solution, making it far gentler and safer for roofs and renders than traditional high-pressure washing." },
  { q: "How much does roof cleaning cost?", a: "Every roof is different, so we provide a fixed-price quote after a free, no-obligation property assessment — you'll always know the price before we start." },
  { q: "Do you clean all render types?", a: "Yes — we tailor our method and solution to your specific render, from modern silicone and acrylic systems to traditional finishes." },
  { q: "Are you insured?", a: "Absolutely. StoneCrest is fully insured on every job for complete peace of mind." },
  { q: "How long does a driveway clean take?", a: "Most domestic driveways take between half a day and a full day, depending on the size, surface type and condition." },
];

export const AREAS = ["Preston", "Chorley", "Leyland", "Lancaster", "Blackburn", "Blackpool"];

export const GALLERY_FILTERS = ["All", "Roof Cleaning", "Render Cleaning", "Driveways", "Gutters", "Fascia & Soffits"];

export const PROPERTY_TYPES = ["Terraced", "Semi-detached", "Detached", "Bungalow"];
